import { useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  DEFAULT_LOCALE,
  isSupportedLocale,
  prefixPathWithLocale,
  readStoredLocale,
} from "./localePaths";

/**
 * Returns a function to prefix internal paths with the active URL locale.
 * Falls back to stored locale when called outside a locale route (should be rare).
 */
export function useLocalizedPath() {
  const params = useParams();
  const fromUrl = params?.locale;

  return useCallback(
    (path) => {
      if (typeof path !== "string") return path;
      const locale =
        isSupportedLocale(fromUrl) ? fromUrl.toLowerCase() : readStoredLocale() || DEFAULT_LOCALE;
      return prefixPathWithLocale(path, locale);
    },
    [fromUrl]
  );
}

/**
 * Like useLocalizedPath but preserves `?query` (e.g. `/auth/onboarding/client?step=1`).
 */
export function useLocalizedHref() {
  const lp = useLocalizedPath();
  return useCallback(
    (href) => {
      if (href == null || typeof href !== "string") return href;
      const q = href.indexOf("?");
      const pathname = q === -1 ? href : href.slice(0, q);
      const search = q === -1 ? "" : href.slice(q);
      return lp(pathname) + search;
    },
    [lp]
  );
}
